import { render } from "./ConfigButton.vue?vue&type=template&id=8b91f524&ts=true"
import script from "./ConfigButton.vue?vue&type=script&lang=ts"
export * from "./ConfigButton.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__